export function sizeMap(size: "xs" | "sm" | "md") {
  switch (size) {
    case "md":
      return {
        tagSizeProps: {
          height: "28px",
          minHeight: "26px",
          borderRadius: "5px",
          px: "3",
        },
        tagLabelSizeProps: {
          fontSize: "sm",
        },
      };
    case "sm":
      return {
        tagSizeProps: {
          height: "20px",
          minHeight: "20px",
          borderRadius: "5px",
          px: "2",
        },
        tagLabelSizeProps: {
          fontSize: "sm",
        },
      };
    default:
      return {
        tagSizeProps: {
          height: "18px",
          minHeight: "16px",
          borderRadius: "5px",
          px: "1",
        },
        tagLabelSizeProps: {
          fontSize: "xs",
        },
      };
  }
}
